import React from "react"
import search from "../../images/icon-search.svg"
import { Button } from "../Button/Button"
import { SearchFormContainer } from "./RecyclopediaForm.styles"

const SearchForm = ({ searchTerm, setSearchTerm, resultCount }) => {
  const handleSubmit = e => {
    e.preventDefault()
    setSearchTerm(searchTerm)
  }

  return (
    <SearchFormContainer>
      <div className="whitebg innerContainer">
        <div className="container">
          <div>
            <form role="search" onSubmit={handleSubmit}>
              <label htmlFor="search" className="primaryTitle">
                Recycleable Search
              </label>
              <br />
              <div className="searchBorder">
                <input
                  id="search"
                  type="search"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
                <Button
                  label="Search"
                  buttonStyle="btn--blue--bg"
                  buttonSize="btn--large"
                  font="primaryLink"
                  type="submit"
                  iconRight={search}
                ></Button>
                <br />
              </div>
            </form>
            <p className="secondaryLabelMax">
              {resultCount > 0 ? (
                <>
                  {" "}
                  {resultCount} result{resultCount !== 1 ? "s" : null} found for{" "}
                  {searchTerm}
                </>
              ) : null}
            </p>
          </div>
        </div>
      </div>
    </SearchFormContainer>
  )
}
export default SearchForm
